export default __webpack_public_path__ + "static/media/img_fahreyad.50dd921e.png";